<template>
    <div class="r-topic-desc">
        <div key="content" class="topic-content" v-html="content" @click="getImg($event)"></div>
    </div>
  </template>
  
  <script type="text/javascript">
  import TopicMix from "./TopicMix";
  import {
    Dialog,
    Toast,
    ImagePreview,
    Loading
  } from "vant";
  import $ from "jquery";
  export default {
    name: "topic-desc",
    mixins: [TopicMix],
    data() {
      return {

      };
    },
    props: {
      juheAppId: [String, Number],
      voteTag: Boolean,
      voteDetail: [Object, String],
      desc: String,
      content: String,
      attachments: String,
      line: {
        type: [String, Number],
        default: 2,
      },
      // 游戏版块名称
      gameName: String,
      // 日期
      date: String,
      isDetail: Boolean,
      userVoteFlag: Boolean,
      roleCheck: [String, Array],
      //图片
      imgs: [Array, String],
      unwrap: Boolean
    },
    methods: {
      getImg($event) {
        if ($event.target.nodeName == "IMG") {
          var innerImg = [$event.target.currentSrc]
          ImagePreview({
            images: innerImg,
            closeable: true,
            showIndex: false,
            loop: false
          })
        }else {
          this.$emit('resetReply')
        }
      },
    },
    watch: {

    },
  };
  </script>
  
  <style lang="less" scoped>
  .r-topic-desc {
    .topic-content {
        color: #5a5a5a;
      figure.image {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
      /deep/img {
        max-width: 100%;
      }
    }
  
    .comment-img {
      display: flex;
      justify-content: center;
      align-items: flex-start;
      flex-direction: column;
      max-height: unset !important;
      background-color: #fff !important;
  
      img {
        display: inline-block;
        margin-bottom: 6px;
        max-width: 100%;
      }
  
      img:nth-last-child(1) {
        margin-bottom: 0;
      }
    }
  }
  
  .vote_content_detail {
    .vote-pregress {
      .ivu-progress-inner {
        background-color: #ffe9cd;
      }
    }
  }
  
  .choose-right-icon {
    width: 36%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  
    .vote-num_and_percent {
      font-size: 12px;
      color: #afafaf;
  
      .vote_num {
        margin-right: 6px;
      }
    }
  }
  </style>